<div class="flex flex-wrap max-w-ultrawide gap-2 justify-between mobile:justify-center">
    <p class="font-bold">{{ 'admin.extraction_result' | transloco}}:</p>
    <div class="relative max-h-[50vh] rounded-[16px] overflow-y-auto w-full">
        <button title="{{ 'admin.copy' | transloco }}" (click)="copyToClipboard(historyItem?.data)"
            class="absolute top-2 right-2 p-2 bg-neutral-200 hover:bg-secondary rounded-full">
            <img src="assets/icons/copy.svg" class="w-[24px] h-[24px]" alt="{{ 'admin.copy' | transloco }}">
        </button>
        <code>
        <pre class="bg-neutral-700 text-sm text-secondary p-4 rounded-[16px] overflow-x-auto whitespace-pre-wrap border border-border">{{ formatJson(historyItem)}}</pre></code>
    </div>

    <p class="font-bold">{{ 'admin.extraction_events' | transloco }}:</p>
    <div class="relative max-h-[50vh] rounded-[16px] overflow-y-auto w-full">
        <code>
        <pre class="bg-neutral-700 text-sm text-secondary p-4 rounded-[16px] overflow-x-auto whitespace-pre-wrap border border-border">{{ formatJson(loadedEventLogs)}}</pre></code>
    </div>
</div>